module.exports = __webpack_public_path__ + "img/humanlines.9209bb43.png";